import React from 'react'
import { ViewTitle, SimpleShowLayout } from 'admin-on-rest'
import { CourseView } from '../components/CourseView'

import { StudentCoursePaymentStatus } from '../components/StudentCoursePaymentStatus'
import { StudentCourseCompletedStatus } from '../components/StudentCourseCompletedStatus'

export default class StudentCoursePageShow extends React.Component {
  getCourseName = course => {
    switch (course.status) {
      case 'cancelled':
        return (
          <p>
            <font color="red">{`CURS ANULAT - ${course.name}`}</font>
          </p>
        )
      case 'completed':
        return `CURS INCHEIAT - '${course.name}'`
      default:
        return `Detalii despre cursul '${course.name}'`
    }
  }
  render() {
    const { course, isEnrolled } = this.props

    if (!course) return null

    // console.log('course show', course)

    return (
      <div>
        <ViewTitle title={this.getCourseName(course)} />
        <SimpleShowLayout record={course}>
          <CourseView />
        </SimpleShowLayout>
        <SimpleShowLayout record={course}>
          {course.status === 'completed' ? (
            <StudentCourseCompletedStatus course={course} />
          ) : (
            <StudentCoursePaymentStatus course={course} />
          )}
        </SimpleShowLayout>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/students/StudentCoursePageShow.js